<script lang="ts">
  import Button from '$shared/atoms/Button/Button.svelte';
import { ButtonStyle } from '$shared/constants/ButtonStyle';
  import Icon from '$shared/atoms/Icon/Icon.svelte';
  import UIDisclaimer from '$provider/constants/UIDisclaimer';

  interface Props {
    disclaimer?: any;
    fieldLabels?: Array<string>;
    name?: string;
    children?: import('svelte').Snippet;
  }

  let {
    disclaimer = UIDisclaimer.AdditionalDetailDisclaimer,
    fieldLabels = [],
    name = 'additionalInfo',
    children
  }: Props = $props();

  let show = $state(false);

  const onClickExpand = (): void => {
    show = !show;
  };
</script>

<div class="comp-additional-info">
  <div class="header">
    <Button {name} style={ButtonStyle.Link} onclick={onClickExpand}>
      <div class="toggler">
        <div class="text">Additional Info</div>
        <div class="icon">
          <Icon value="{show ? 'icon-chevron-up' : 'icon-chevron-down'} active" />
        </div>
      </div>
    </Button>
    <div data-cy={`${name}-desc`} class="desc">
      {show ? disclaimer : fieldLabels.join(', ')}
    </div>
  </div>
  <div class="container" class:show>
    {@render children?.()}
  </div>
</div>

<style>
  .header {
    margin-bottom: 16px;
  }
  .desc {
    font-weight: normal;
    font-size: 11px;
    line-height: 18px;
    color: var(--grey-medium);
    margin-top: 4px;
  }
  .container {
    display: none;
  }
  .container.show {
    display: block;
  }
  .toggler {
    margin-left: -16px;
    display: flex;
    align-items: center;
  }
  .toggler .icon {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: 4px;
    margin-bottom: -1px;
  }
</style>
